exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@tailwind base;@tailwind components;@tailwind utilities;", "", {"version":3,"sources":["/var/www/superhote.com/front/public/2025-07-28.134721/src/tailwind.css"],"names":[],"mappings":"AAAA,eAAe,AACf,qBAAqB,AACrB,oBAAoB","file":"tailwind.css","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./src/tailwind.css
// module id = 1101
// module chunks = 0